import { useEffect } from 'react';
import { useMyContext } from 'Context/MyContextProvider';

/**
 * Checks if the current user has the required permission or is an Admin.
 * Returns a boolean.
 */
export const usePermission = (permission) => {
    const { Permisson, userRole } = useMyContext();
    return userRole === 'Admin' || Permisson?.includes(permission);
};

/**
 * Hook that redirects the user if they do not have the required permission.
 */
export const usePermissionGuard = (permission, redirectPath = '/404') => {
    const { navigate } = useMyContext();
    const hasPermission = usePermission(permission);

    useEffect(() => {
        if (!hasPermission) {
            navigate(redirectPath);
        }
    }, [hasPermission, navigate, redirectPath]);

    return hasPermission;
};

/**
 * Component wrapper that only renders its children if the user has permission.
 * Also redirects to redirectPath if the check fails.
 */
export const PermissionProtected = ({ permission, redirectPath = '/404', children }) => {
    const hasPermission = usePermissionGuard(permission, redirectPath);

    if (!hasPermission) {
        return null;
    }

    return children;
};

export default usePermissionGuard;